// EXPORTS: SPORT_AVATARS
// 内置运动头像库（扁平插画风、方形）
export interface ISportAvatar {
  id: string;
  label: string;
  url: string;
}

export const SPORT_AVATARS: ISportAvatar[] = [
  {
    id: 'running',
    label: '跑步',
    url: '/media/optimized/avatars/running.webp',
  },
  {
    id: 'yoga',
    label: '瑜伽',
    url: '/media/optimized/avatars/yoga.webp',
  },
  {
    id: 'weightlifting',
    label: '力量举',
    url: '/media/optimized/avatars/weightlifting.webp',
  },
  {
    id: 'boxing',
    label: '拳击',
    url: '/media/optimized/avatars/boxing.webp',
  },
  {
    id: 'basketball',
    label: '篮球',
    url: '/media/optimized/avatars/basketball.webp',
  },
  {
    id: 'swimming',
    label: '游泳',
    url: '/media/optimized/avatars/swimming.webp',
  },
  {
    id: 'cycling',
    label: '骑行',
    url: '/media/optimized/avatars/cycling.webp',
  },
  {
    id: 'jump-rope',
    label: '跳绳',
    url: '/media/optimized/avatars/jump-rope.webp',
  },
];

// 默认头像（未设置时使用第一张）
export const DEFAULT_AVATAR = SPORT_AVATARS[0].url;
